import { AxiosError, HttpStatusCode } from 'axios';

import { RestClient } from '../../../common/RestClient';

export class AuthenticationService extends RestClient {
  constructor() {
    super();
  }

  execute = async (): Promise<void> => {
    try {
      await this.post('/lacreiid/auth/token/verify/');
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error.response?.status === HttpStatusCode.Unauthorized
      ) {
        throw new Error('Não autorizado.');
      }
      throw new Error(
        'Falha na comunicação com o servidor. Por favor, tente novamente mais tarde.',
      );
    }
  };
}
